import React, { useEffect, useMemo, useState } from "react";
import style from "./style";
import {
  Box,
  Grid,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ReactComponent as Edit } from "../../assets/images/edit.svg";
import Modal from "../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useAlert } from "../../context/AlertContext";
import { getDateFormat } from "../../utils/dateFormatStore";

const TaxTablePage = ({
  data = {},
  handleTaxTable,
  handleAddTaxYear,
  success,
  handledeleteTextTable,
  handleEditTaxTable,
  taxCountry,
  taxPeriod,
  getYearTaxTable,
  year,
  handleFrequencyChange,
  ageGroupData,
  frequency,
  handleImport,
  loading,
  handleDeleteAllTextTable
}) => {
  const dataRes = Array.isArray(data) ? data : (data?.results || []);
  const [max, setMax] = useState();
  const [rate, setRate] = useState();
  const [countryTax, setCountryTax] = useState();
  const [open, setOpen] = useState(false);
  const [min, setMin] = useState();
  const [fixed, setFixed] = useState();
  const [datefrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null)
  const [openDelete, setOpenDelete] = useState(false)
  const [editMode, setEditMode] = useState(false);
  const [selectedTaxSlab, setSelectedTaxSlab] = useState(null);
  const [selectedTaxYear, setSelectedTaxYear] = useState("");
  const [yearId, setYearId] = useState("");
  const [addFY, setAddFY] = useState(false)
  const [addStart, setAddStart] = useState(null)
  const [addEnd, setAddEnd] = useState(null)
  const [selectedTaxTableId, setSelectedTaxTableId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);
  const [originalValues, setOriginalValues] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const { showAlert } = useAlert();
  const role = localStorage.getItem("role");
  const countryPermissions = JSON.parse(
    localStorage.getItem("countryPermissions") || "{}"
  );

  const permissions = Object.values(countryPermissions)[0] || {};

  const canEditTaxTable = role === "SuperAdmin" ||
    permissions?.taxTable?.edit === true;

  const toStringOrEmpty = (value) =>
    value === null || value === undefined || Number.isNaN(value) ? "" : String(value);

  const numericInputPattern = /^\d*\.?\d*$/;

  const handleNumericInput = (setter) => (event) => {
    const { value } = event.target;
    if (value === "" || numericInputPattern.test(value)) {
      setter(value);
    }
  };

  useEffect(() => {
    if (year) {
      setSelectedTaxYear(year);
      setYearId(year);
    }
  }, [year]);


  useEffect(() => {
    if (!open) {
      setMin("");
      setMax("");
      setFixed("");
      setRate("");
      setSelectedTaxSlab(null);
      setCountryTax("");
      setSelectedTaxTableId(null);
      setDateFrom(null);
      setDateTo(null);
      setEditMode(false);
      setAddFY(false);
      setOriginalValues(null);
    }
  }, [open]);

  const handleTaxYearChange = async (event) => {
    try {
      setIsDataReady(false); // Reset data ready state
      setSelectedTaxYear(event.target.value);
      setYearId(event.target.value);
      await getYearTaxTable(event.target.value, taxCountry);
    } catch (error) {
      setIsDataReady(false); // Ensure loading state is reset on error
    }
  };

  const handleDeleteItem = () => {
    if (selectedItems.length > 0) {
      const taxTableId = selectedItems[0].taxTableId;
      const slabIds = selectedItems.map(item => item.slabId);
      handleDeleteAllTextTable(taxTableId, slabIds);
    } else {
      handledeleteTextTable(selectedTaxTableId, selectedTaxSlab);
    }
    setSelectedItems([]);
    setOpenDelete(false);
  };

  const deleteData = (taxTableId, slabId) => {
    setSelectedItems([]);
    setSelectedTaxTableId(taxTableId);
    setSelectedTaxSlab(slabId);
  };

  const handleOpenModal = (item, slab) => {
    setMin(toStringOrEmpty(slab?.minIncome ?? item?.minIncome));
    setMax(toStringOrEmpty(slab?.maxIncome ?? item?.maxIncome));
    setFixed(
      toStringOrEmpty(
        slab?.fixedAmount ??
        slab?.fixed ??
        item?.fixedAmount ??
        item?.fixed
      )
    );
    setRate(
      toStringOrEmpty(
        slab?.ratePercentage ??
        slab?.rate ??
        item?.ratePercentage ??
        item?.rate
      )
    );
    setSelectedTaxSlab(slab?._id ?? null);
    setSelectedTaxTableId(item?._id ?? null);
    setCountryTax(item?.country ?? taxCountry ?? dataRes?.[0]?.country ?? "");
    setDateFrom(item?.startYear ?? dataRes?.[0]?.startYear ?? datefrom);
    setDateTo(item?.endYear ?? dataRes?.[0]?.endYear ?? dateTo);
    setEditMode(true);
    setAddFY(false);
    setOpen(true);
    setOriginalValues({
      min: toStringOrEmpty(slab?.minIncome ?? item?.minIncome ?? ""),
      max: toStringOrEmpty(slab?.maxIncome ?? item?.maxIncome ?? ""),
      fixedAmount: toStringOrEmpty(
        slab?.fixedAmount ??
        slab?.fixed ??
        item?.fixedAmount ??
        item?.fixed ??
        ""
      ),
      ratePercentage: toStringOrEmpty(
        slab?.ratePercentage ??
        slab?.rate ??
        item?.ratePercentage ??
        item?.rate ??
        ""
      ),
    });
  };

  const parseNumber = (value) => {
    if (value === "" || value === null || value === undefined) return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const isTaxSlabFormValid = () => {
    const minValue = parseNumber(min);
    const fixedValue = parseNumber(fixed);
    const rateValue = parseNumber(rate);
    const maxValue =
      max === "" || max === null || max === undefined ? null : parseNumber(max);

    if (minValue === null || minValue < 0) return false;
    if (fixedValue === null || fixedValue < 0) return false;
    if (rateValue === null || rateValue < 0) return false;
    if (!countryTax) return false;
    if (!editMode && !addFY && (!datefrom || !dateTo)) return false;

    if (max !== "" && maxValue === null) return false;
    if (maxValue !== null && maxValue <= minValue) return false;

    return true;
  };

  const isFinancialYearValid = () => {
    if (!addStart || !addEnd) return false;
    const start = dayjs(addStart);
    const end = dayjs(addEnd);
    return end.isAfter(start, "day");
  };

  const handleSave = () => {
    const minValue = parseNumber(min);
    const maxValue = max === "" ? null : parseNumber(max);
    const fixedValue = parseNumber(fixed);
    const rateValue = parseNumber(rate);

    if (addFY) {
      if (!isFinancialYearValid()) {
        showAlert?.("End date must be after start date", "error");
        return;
      }
      handleAddTaxYear(addStart, addEnd);
    } else if (editMode) {
      if (!hasTaxSlabChanges) return;
      if (!isTaxSlabFormValid()) return;
      handleEditTaxTable(
        selectedTaxSlab,
        selectedTaxTableId,
        minValue,
        maxValue,
        fixedValue,
        rateValue,
        countryTax || taxCountry,
        yearId
      );
      setEditMode(false);
      setMin("");
      setMax("");
      setFixed("");
      setRate("");
    } else {
      if (!isTaxSlabFormValid()) return;
      handleTaxTable(
        minValue,
        maxValue,
        fixedValue,
        rateValue,
        countryTax || dataRes?.[0]?.country,
        datefrom,
        dateTo,
        selectedTaxTableId,
        yearId,
        frequency
      );
    }
    setOpen(false);
    setDateFrom(null);
    setDateTo(null);
  };

  const handleDateChange = () => {
    const getYear = taxPeriod?.find((item) => item._id === yearId);
    const yearStart = getYear?.start;
    const yearEnd = getYear?.end;
    setDateFrom(yearStart || dataRes?.[0]?.startYear);
    setDateTo(yearEnd || dataRes?.[0]?.endYear);
  };

  const hasSlabs = useMemo(() => {
    if (!Array.isArray(dataRes)) return false;
    return dataRes.some((item) => Array.isArray(item?.taxSlabs) && item.taxSlabs.length > 0);
  }, [dataRes]);

  const hasTaxSlabChanges = useMemo(() => {
    if (!editMode || !originalValues) return true;
    return !(
      toStringOrEmpty(min) === originalValues.min &&
      toStringOrEmpty(max) === originalValues.max &&
      toStringOrEmpty(fixed) === originalValues.fixedAmount &&
      toStringOrEmpty(rate) === originalValues.ratePercentage
    );
  }, [editMode, originalValues, min, max, fixed, rate]);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2, mt: 3, ml: 3, mr: 2 }}>
        <Typography sx={style.gridText}>Tax Tables</Typography>
      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={12} sx={style.gridbox}>
          <Box sx={style.modalGrid}>
            <Box sx={style.heading}>
              <Typography sx={style.head}>{taxCountry || dataRes?.[0]?.country}</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
              {canEditTaxTable && (
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={{ ...style.jobButtons, height: "2.8em" }}
                  onClick={() => {
                    handleDateChange();
                    setMin("");
                    setMax("");
                    setFixed("");
                    setRate("");
                    setSelectedTaxSlab(null);
                    setSelectedTaxTableId(
                      success === false
                        ? undefined
                        : dataRes?.[0]?._id || null
                    );
                    setOpen(true);
                    setAddFY(false);
                    setCountryTax(taxCountry || dataRes?.[0]?.country);
                    const initialValues = {};
                    ageGroupData.forEach((ageGroup) => {
                      initialValues[ageGroup._id] = "";
                    });
                  }}
                >+ Add Tax Slab
                </Button>
              )}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, height: "2.8em" }}>
                <Typography sx={{ fontSize: "15px", fontWeight: "600", whiteSpace: "nowrap", display: "flex", alignItems: "center", height: "100%" }}>FY</Typography>
                <FormControl sx={{
                  minWidth: "200px",
                  height: "3.5em",
                  "& .MuiOutlinedInput-root": {
                    height: "2.8em",
                    borderRadius: "10px"
                  }
                }}>
                  <Select
                    value={selectedTaxYear || ""}
                    onChange={handleTaxYearChange}
                    name="taxyear"
                    sx={style.dropdown}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span style={{ color: '#9e9e9e' }}>Select FY</span>;
                      }
                      const selectedPeriod = taxPeriod?.find(item => item._id === selected);
                      return selectedPeriod
                        ? `${dayjs(selectedPeriod.start).format(getDateFormat())} - ${dayjs(selectedPeriod.end).format(getDateFormat())}`
                        : "Select FY";
                    }}
                  >
                    <MenuItem value="" disabled>Select FY</MenuItem>
                    {taxPeriod?.map((item) => (
                      <MenuItem key={item._id} sx={style.dropDownMenu} value={item._id}>
                        {dayjs(item.start).format(getDateFormat())} - {dayjs(item.end).format(getDateFormat())}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Box>
          <TableContainer sx={style.noShadow}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={style.tableHead}>Taxable Income (R)</TableCell>
                  <TableCell sx={style.tableHead}>Rates of Tax (R)</TableCell>
                  {canEditTaxTable && (
                    <TableCell sx={style.tableHead}>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell
                      colSpan={canEditTaxTable ? 3 : 2}
                      align="center"
                    >
                      <Typography variant="h6">Preparing data...</Typography>
                    </TableCell>
                  </TableRow>
                ) : !hasSlabs ? (
                  <TableRow>
                    <TableCell
                      colSpan={canEditTaxTable ? 3 : 2}
                      align="center"
                    >
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : success === false ? (
                  <TableRow>
                    <TableCell
                      colSpan={canEditTaxTable ? 3 : 2}
                      align="center"
                    >
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  dataRes?.map((item) =>
                    (item?.taxSlabs || []).map((slab, index) => (
                      <TableRow key={`${item?._id || "slab"}-${slab?._id || index}`}>
                        <TableCell>
                          {(slab?.minIncome ?? item?.minIncome ?? 0)} -{" "}
                          {slab?.maxIncome ?? item?.maxIncome ?? "Above"}
                        </TableCell>
                        <TableCell sx={style.tableData}>
                          {(slab?.fixedAmount ?? item?.fixedAmount ?? 0)} + {(slab?.ratePercentage ?? item?.ratePercentage ?? 0)}% of taxable
                          income above {(slab?.minIncome ?? item?.minIncome ?? 0)}
                        </TableCell>
                        {canEditTaxTable && (
                          <TableCell sx={style.tabledata}>
                            <Box sx={style.tableActiondata}>
                              <Edit
                                style={{ cursor: "pointer", margin: 3 }}
                                onClick={() => handleOpenModal(item, slab)}
                              />

                              <DeleteOutlineIcon
                                sx={{ color: "#ff0000" }}
                                onClick={() => {
                                  deleteData(item?._id, slab?._id);
                                  setOpenDelete(true);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      <Modal
        open={open}
        setOpen={setOpen}
        disabled={
          addFY
            ? !isFinancialYearValid()
            : editMode
              ? !isTaxSlabFormValid() || !hasTaxSlabChanges
              : !isTaxSlabFormValid()
        }
        btnText={editMode ? "Update Tax Slab" : addFY ? "Add Financial Year" : "Add Tax Slab"}
        title={editMode ? "Update Tax Slab" : addFY ? "Add Financial Year" : "Add Tax Slab"}
        handleCheck={handleSave}
      >
        <Box sx={style.modalGrid}>
          {!addFY && <Box sx={style.box2}>
            <InputLabel sx={style.label}>Minimun Income</InputLabel>
            <TextField
              size="small"
              name="desc"
              value={min}
              onChange={handleNumericInput(setMin)}
              sx={style.box2}
              type="number"
              inputProps={{ min: 0, step: "0.01" }}
              placeholder={editMode ? "Update minimum income" : "Enter minimum income"}
            />
          </Box>}
          {!addFY && <Box sx={style.box2}>
            <InputLabel sx={style.label}>Maximum Income</InputLabel>
            <TextField
              size="small"
              name="desc"
              value={max}
              onChange={handleNumericInput(setMax)}
              sx={style.box2}
              type="number"
              inputProps={{ min: 0, step: "0.01" }}
              placeholder={editMode ? "Update maximum income" : "Enter maximum income"}
            />
          </Box>}
        </Box>
        {!addFY && <Box sx={style.modalGrid}>
          <Box sx={style.box2}>
            <InputLabel sx={style.label}>Fixed Amount</InputLabel>
            <TextField
              size="small"
              name="desc"
              value={fixed}
              onChange={handleNumericInput(setFixed)}
              sx={style.box2}
              type="number"
              inputProps={{ min: 0, step: "0.01" }}
              placeholder={editMode ? "Update fixed amount" : "Enter fixed amount"}
            />
          </Box>
          <Box sx={style.box2}>
            <InputLabel sx={style.label}>Rate Percent</InputLabel>
            <TextField
              size="small"
              name="desc"
              value={rate}
              onChange={handleNumericInput(setRate)}
              sx={style.box2}
              type="number"
              inputProps={{ min: 0, step: "0.01" }}
              placeholder={editMode ? "Update rate percentage" : "Enter rate percentage"}
            />
          </Box>
        </Box>}
        {addFY && <Box sx={style.modalGrid}>
          {!editMode && <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>From</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={addStart ? dayjs(addStart) : null}
                readOnly={editMode}
                slotProps={{
                  textField: {
                    size: "small"
                  },
                  field: {
                    readOnly: true
                  }
                }}
                sx={style.calenderInput}
                onChange={(newValue) => { setAddStart(newValue); }}
              />
            </LocalizationProvider>
          </Box>}
          {addFY && <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>To</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={addEnd ? dayjs(addEnd) : null}
                slotProps={{
                  textField: {
                    size: "small"
                  },
                  field: {
                    readOnly: true
                  }
                }}
                sx={style.calenderInput}
                onChange={(newValue) => setAddEnd(newValue)}
              />
            </LocalizationProvider>
          </Box>}
        </Box>}
      </Modal>
      <Modal
        open={openDelete}
        setOpen={setOpenDelete}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Text Slab"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default TaxTablePage;
